import { Route } from '@angular/router';
import { createAura404Route } from '@workspace/ng-aura/lib/routes/common.routes';

export const etxe404Route: Route = createAura404Route({
  title: 'Page non trouvée (404)',
  description:
    "La page demandée n'existe pas sur ETXE. Retrouvez notre marketplace d'agents immobiliers certifiés Carte T sur la page d'accueil.",
  badgeText: 'Erreur 404: Page introuvable',
  heading: "Oups ! La page que vous cherchez n'existe pas",
  responseTimeText: "Besoin d'aide ? Notre équipe vous répond sous 48 heures ouvrées.",
  homeUrl: '/',
  homeButtonText: "Retour à l'accueil",
});
